import { AfterViewInit, Component, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { Socket } from 'socket.io-client';
import { SolicitudesPreciosAdministracionService } from 'src/app/services/empresa/solicitudes-precios-administracion.service';

@Component({
    selector: 'app-administracion-solicitud-precios',
    templateUrl: './administracion-solicitud-precios.component.html',
    styleUrls: ['./administracion-solicitud-precios.component.scss'],
    standalone: false
})
export class AdministracionSolicitudPreciosComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  isDtInitialized = false;

  public solicitudes: any[] = [];
  public cargando = false;
  public procesandoId = '';
  private socket?: Socket;

  constructor(
    private solicitudesPreciosAdministracionService: SolicitudesPreciosAdministracionService,
    private toastr: ToastrService,
    private zone: NgZone
  ) {}

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      order: [[0, 'desc']],
      language: LanguageApp.spanish_datatables
    };

    this.obtenerSolicitudesPendientes();
    this.conectarSolicitudesTiempoReal();
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {
    this.socket?.disconnect();
    this.dtTrigger.unsubscribe();
  }

  obtenerSolicitudesPendientes() {
    this.cargando = true;

    this.solicitudesPreciosAdministracionService.listarPendientes(localStorage.getItem('token') || '').subscribe((resp: any) => {
      const data = Array.isArray(resp) ? resp : resp?.rows ?? resp?.data ?? [];
      this.solicitudes = data;
      this.cargando = false;

      if (!this.isDtInitialized) {
        this.dtTrigger.next(null);
        this.isDtInitialized = true;
        return;
      }

      this.rerender();
    });
  }

  confirmarProcesarSolicitud(solicitud: any, accion: 'aprobar' | 'rechazar') {
    const idSolicitud = String(solicitud?.COD_SOLPREC || '');
    const numeroSolicitud = String(solicitud?.NUM_SOLPREC || idSolicitud);

    const esAprobacion = accion === 'aprobar';

    Swal.fire({
      icon: 'warning',
      title: esAprobacion ? '¿Aceptar solicitud?' : '¿Rechazar solicitud?',
      text: `Solicitud N° ${numeroSolicitud}`,
      showCancelButton: true,
      confirmButtonColor: esAprobacion ? '#28a745' : '#d33',
      cancelButtonColor: '#6c757d',
      confirmButtonText: esAprobacion ? 'Si, aceptar' : 'Si, rechazar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (!result.isConfirmed) {
        return;
      }

      this.procesarSolicitud(idSolicitud, accion);
    });
  }

  private procesarSolicitud(idSolicitud: string, accion: 'aprobar' | 'rechazar') {
    if (!idSolicitud) {
      return;
    }

    this.procesandoId = idSolicitud;

    this.solicitudesPreciosAdministracionService
      .cambiarEstado(idSolicitud, accion, localStorage.getItem('token') || '')
      .subscribe({
        next: () => {
          this.procesandoId = '';
          this.obtenerSolicitudesPendientes();
        },
        error: () => {
          this.procesandoId = '';
          this.toastr.error('No se pudo procesar la solicitud.', 'Atención', {
            timeOut: 3500,
            closeButton: true,
            progressBar: true
          });
        }
      });
  }

  private rerender(): void {
    if (!this.dtElement) {
      return;
    }

    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }

  private conectarSolicitudesTiempoReal(): void {
    this.socket = this.solicitudesPreciosAdministracionService.conectarSocket();

    this.socket.on('price_request.created', () => {
      this.zone.run(() => {
        this.toastr.info('Nueva solicitud de cambio de precio.', 'Solicitud recibida', {
          timeOut: 2500,
          closeButton: true,
          progressBar: true
        });
        this.obtenerSolicitudesPendientes();
      });
    });

    this.socket.on('price_request.changed', () => {
      this.zone.run(() => this.obtenerSolicitudesPendientes());
    });
  }
}

export class LanguageApp {
  public static spanish_datatables = {
    processing: 'Procesando...',
    search: 'Buscar:',
    lengthMenu: 'Mostrar _MENU_ registros',
    info: 'Mostrando desde _START_ al _END_ de _TOTAL_ elementos',
    infoEmpty: 'Mostrando ningún elemento.',
    infoFiltered: '(filtrado _MAX_ elementos total)',
    infoPostFix: '',
    loadingRecords: 'Cargando registros...',
    zeroRecords: 'No se encontraron registros',
    emptyTable: 'No hay datos disponibles en la tabla',
    paginate: {
      first: 'Primero',
      previous: 'Ant',
      next: 'Sig',
      last: 'Último'
    },
    aria: {
      sortAscending: ': Activar para ordenar la tabla en orden ascendente',
      sortDescending: ': Activar para ordenar la tabla en orden descendente'
    }
  };
}
